export function isCallHistoryAmountEarned(item: {
  direction: 'outgoing' | 'incoming';
  amount_kind?: 'spent' | 'earned';
}): boolean {
  // Yeni API ekonomik rolü açıkça taşır. Alanı henüz göndermeyen eski API ile
  // kısa geçişte önceki gelen=kazanılan varsayımı korunur.
  return item.amount_kind
    ? item.amount_kind === 'earned'
    : item.direction === 'incoming';
}
